<template>
  <div class="col mt-3">
    <!-- ------------------------- -->
    <!-- close -->
    <div class="row d-flex justify-content-center">
      <button
        type="button"
        class="mt-2 mb-2 btn btn-primary btn-xl btn-circle d-flex justify-content-center align-items-center"
      >
        <ToolTip
          text="Close Characters"
          position="right"
        >
          <img
            :src="exitImg"
            @click="closeHandler()"
            height="48"
            width="48"
            alt="exit image"
          />
        </ToolTip>
      </button>
    </div>

    <!-- add character -->
    <div class="d-flex justify-content-center">
      <button
        type="button"
        :disabled="!allowAdd"
        class="mt-2 mb-2 btn btn-xl btn-primary btn-circle d-flex justify-content-center align-items-center"
        @click="addCharacterHandler()"
      >
        <ToolTip
          text="Add Character"
          position="right"
        >
          <i
            class="bi bi-plus"
            style="color: white; font-size: 5em"
          ></i>
        </ToolTip>
      </button>
    </div>
  </div>
</template>

<script>
import ToolTip from '../components/ToolTip.vue'
import exitImg from '../assets/images/bbExit100.png'

//==========================================================
// scripts
//---------
export default {
  name: 'CharacterButtonsPanel',
  components: {
    ToolTip,
  },
  props: {
    allowAdd: {
      type: Boolean,
      default: true,
    },
  },
  //==========================================================
  // data
  //------
  data() {
    return {
      exitImg,
    }
  },
  //==========================================================
  // methods
  //---------
  methods: {
    //---------------
    // close handler
    //---------------
    closeHandler() {
      this.$emit('close-character')
    },
    //------------------------------
    // show character sheet handler
    //------------------------------
    addCharacterHandler() {
      this.$emit('add-character')
    },
  },
  //==========================================================
  // mounted
  //--------
  mounted() {},
}
</script>
